import { useParams } from 'react-router';

/**
 * Returns route params represented as numbers.
 * NaN will be the value of any route values that cannot be parsed as an integer.
 * For parameter values that are not expected to be numeric, recommend using the standard 'useParams' instead.
 */
export function useNumberIdsFromRoute<Params extends { [K in keyof Params]: string } = Record<string, string>>() {
    const output = {} as { [key in keyof Params]: number };

    const strParams = useParams<Params>();

    for (const key of Object.keys(strParams) as (keyof Params)[]) {
        // This will place NaN into any properties that cannot be
        // converted to a number. I think this is okay, and 'better'
        // than allowing undefined as an option.
        const numParseResult = parseInt(strParams[key], 10);
        output[key] = numParseResult;
    }

    return output;
}